import { localKeys, sessionKeys } from '@m2h/common/constants';
import { owlAddAjaxInfo } from '@m2h/common/raptor';
import { safeParse } from '@m2h/common/utils/common';
import { isArray, isObject } from 'lodash';

export function storeMachSchemeData({ localKey, machConfig }: { localKey?; machConfig; }) {
  const realKey = localKey || `${localKeys.LOCAL_MACH_SCHEME_DATA}${window.location.pathname}`;
  localStorage.setItem(realKey, JSON.stringify({
    data: machConfig?.data || {},
    env: { schemeParams: machConfig?.env?.schemeParams },
  }));
}

// storage存储Mach对象（env、data）
export function storeMachObject(options?) {
  const {
    machConfig = window.Mach,
    storeLocal = false,
  } = options || {};
  sessionStorage.setItem(sessionKeys.SESSION_MACH_ENV, JSON.stringify(machConfig.env));
  sessionStorage.setItem(sessionKeys.SESSION_MACH_DATA, JSON.stringify(machConfig.data));
  // SESSION_MACH_SCHEMEPARAMS 目前仅在支付场景里set
  if (storeLocal) {
    const localKey = `${localKeys.LOCAL_MACH_SCHEME_DATA}${window.location.pathname}`;
    storeMachSchemeData({ localKey, machConfig, ...options });
  }
}

// 获取localstorage上当前页面的缓存数据, 路由跳转是，需要等路由确定后，或主动传入路由
export function getLocalSchemeData(routerPath?) {
  const pathName = routerPath || window.location.pathname;
  console.log('bundleName 优先级xx getLocalSchemeData', pathName);

  if (!pathName) return window.Mach; // 避免返回非预期值
  const key = `${localKeys.LOCAL_MACH_SCHEME_DATA}${routerPath || window.location.pathname}`;
  return safeParse(localStorage.getItem(key), window.Mach);
}

// storage值更新Mach对象（env、data）
// 页面刷新时恢复数据(不包含路由跳转的存储)
export function updateMachObjectWithStore(store = false) {
  console.log('bundleName 优先级xxx updateMachObjectWithStore', window.Mach.env);

  const storedMachEnv = safeParse(sessionStorage.getItem(sessionKeys.SESSION_MACH_ENV), '');
  const storedMachData = safeParse(sessionStorage.getItem(sessionKeys.SESSION_MACH_DATA), '');

  // Mach.env
  if (storedMachEnv) {
    const m2h_mach_schemeParams = safeParse(sessionStorage.getItem(sessionKeys.SESSION_MACH_SCHEMEPARAMS), '');

    if (m2h_mach_schemeParams) {
      sessionStorage.setItem(sessionKeys.SESSION_MACH_SCHEMEPARAMS, ''); // SESSION_MACH_SCHEMEPARAMS,用完即清除
      storedMachEnv.schemeParams = {
        ...storedMachEnv.schemeParams,
        ...m2h_mach_schemeParams,
      };
    }

    window.Mach.env = {
      ...window.Mach.env,
      ...storedMachEnv,
    };
  }
  // Mach.data
  if (storedMachData) {
    window.Mach.data = {
      ...window.Mach.data,
      ...storedMachData,
    };
  }

  store && storeMachObject(); // ? 是否需要存
}

// https://km.sankuai.com/collabpage/2652780699
// storage存储Mach对象清理: data 和 env.schemeParams
// 刷新页面时，整体应用入口处清理
// 路由跳转时：走到Router的Router里清理 | 不走Router的暂无时机
// TODO: 是否应该不清理，而是按页面路径各自独立隔离存储和更新？
export function clearStoredPageMach() {
  console.log('bundleName', 'clearStoredPageMach');
  // window.Mach.env = {
  //   ...window.Mach.env,
  //   schemeParams: {},
  // };
  sessionStorage.setItem(sessionKeys.SESSION_MACH_ENV, JSON.stringify(window.Mach.env));
  sessionStorage.setItem(sessionKeys.SESSION_MACH_DATA, JSON.stringify({}));
  storeMachSchemeData({ machConfig: {} });
  // SESSION_MACH_SCHEMEPARAMS 目前仅在支付场景里set
}

// 合并配置到window.Mach
export function mergeMachConfig2Window(machConfig, store = true, storeLocal = false) {
  // window.Mach
  Object.entries(machConfig || {}).forEach(([key, values]: any) => {
    const oriMachH5Config = window.Mach[key];
    if (isObject(oriMachH5Config)) {
      // 字段为对象
      Object.entries(values).forEach(([k, value]: any) => {
        const oriEnvVal = window.Mach[key][k];
        if (isObject(oriEnvVal)) {
          window.Mach[key][k] = { ...oriEnvVal, ...value };
        } else if (isArray(oriEnvVal)) {
          window.Mach[key][k] = [...oriEnvVal, ...value];
        } else {
          window.Mach[key][k] = value;
        }
      });
    } else if (isArray(oriMachH5Config)) {
      // 字段为数字
      window.Mach[key] = [...oriMachH5Config, ...values];
    } else {
      // 字段为普通值
      window.Mach[key] = values;
    }
  });
  // 更新存储
  store && storeMachObject({ storeLocal });
}

// 直接根据machConfig一级字段替换更新对应字段并存储
// 主要是env/data/ env.schemeParams,
export function replaceMachConfig2Window(machConfig, store = true) {
  Object.entries(machConfig || {}).forEach(([key, values]: any) => {
    window.Mach[key] = values;
  });
  store && storeMachObject();
}

let hasSchemeData = false;
// 替换更新data | env.schemeParams,
export function replaceMachSchemeData2Window(machConfig, isNewSchemeData?) {
  if (!hasSchemeData || isNewSchemeData) {
    window.Mach.data = machConfig?.data || {};
    window.Mach.env.schemeParams = machConfig?.env?.schemeParams || {};
    hasSchemeData = isNewSchemeData;
  }
}

// 设置window.Mach上的env.schemeParams
export const setSchemeParams = (key: string, value: any) => {
  !window.Mach?.env && (window.Mach.env = {});
  !window.Mach?.env.schemeParams && (window.Mach.env.schemeParams = {});
  window.Mach.env.schemeParams[key] = value;
};

export const setMachEnv = (key: string, value: any) => {
  !window.Mach?.env && (window.Mach.env = {});
  window.Mach.env[key] = value;
};

// 统一的参数提取函数
// @ts-ignore
export function extractSearchParams(input: SearchParamsInput): URLSearchParams {
  const emptySearchParams = new URLSearchParams('');
  if (!input) return emptySearchParams;

  // 处理 URLSearchParams 实例
  if (input instanceof URLSearchParams) {
    return input;
  }

  // 处理 useSearchParams() 返回的数组格式 [searchParams, setSearchParams]
  if (Array.isArray(input) && input.length >= 1) {
    const [searchParams] = input;
    return searchParams instanceof URLSearchParams ? searchParams : emptySearchParams;
  }

  // 处理字符串格式 (如 "?key=value&key2=value2")
  if (typeof input === 'string') {
    try {
      return new URLSearchParams(input);
    } catch (error) {
      console.warn('Invalid search params string:', input, error);
      return emptySearchParams;
    }
  }

  // 处理普通对象格式 { key: value, key2: value2 }
  if (typeof input === 'object' && input.constructor === Object) {
    const params = new URLSearchParams();
    Object.entries(input).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // 处理数组值
        value.forEach((v) => params.append(key, String(v)));
      } else if (value !== null && value !== undefined) {
        params.set(key, String(value));
      }
    });
    return params;
  }

  console.warn('Unsupported search params format:', typeof input, input);
  return emptySearchParams;
}

// 优先级： 1.实时计算值 > 2.url参数转化值 > 3.页面入口自定义初始化值 > 4.缓存值
// 优先级：2.优化后的 useSearchParamsInit 函数
// 最大兼容性的URLSearchParams遍历辅助函数
const mergeParamsFromString = (paramsObj: URLSearchParams, targetParams: URLSearchParams) => {
  const paramString = paramsObj.toString();
  if (paramString) {
    const pairs = paramString.split('&');
    pairs.forEach((pair) => {
      const [key, value] = pair.split('=').map(decodeURIComponent);
      if (key) {
        targetParams.set(key, value || '');
      }
    });
  }
};

const mergeParamsBasic = (sourceParams: URLSearchParams, targetParams: URLSearchParams) => {
  // 尝试从字符串中提取所有键名
  const sourceString = sourceParams.toString();
  if (sourceString) {
    const keys = sourceString.split('&').map((pair) => pair.split('=')[0]).map(decodeURIComponent);
    keys.forEach((key) => {
      if (key && sourceParams.has(key)) {
        const value = sourceParams.get(key);
        if (value !== null) {
          targetParams.set(key, value);
        }
      }
    });
  }
};

// 便民函数：批量设置多个参数
export const batchSetSchemeParams = (params: Record<string, any>): void => {
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      setSchemeParams(key, value);
    }
  });
};

export const initShopSearchKeyword = (key: string, value: string) => {
  setSchemeParams(key, value);
};

// 修复方法签名
// @ts-ignore
export const searchShopKeyToValues: KeyToValueItem[] = [
  {
    key: 'keyword',
    method: (key: string, value: string) => initShopSearchKeyword(key, value),
  },
];

export const initShopId = (key: string, value: string) => {
  setSchemeParams('shopId', value);
  setSchemeParams('shop_id', value);
};

// @ts-ignore
export const keyToValues: KeyToValueItem[] = [
  {
    key: 'shopId',
    method: initShopId,
  },
  {
    key: 'region',
    method: setMachEnv,
  },
  {
    key: 'locale',
    method: setMachEnv,
  },
];

// scope: subPackages
export async function loadRemoteModule(scope: string, subBundleName: string) {
  try {
    // 初始化共享作用域
    // @ts-ignore
    await __webpack_init_sharing__('default');

    // 获取容器
    const container = window[scope];
    // 初始化容器
    // @ts-ignore
    await container.init(__webpack_share_scopes__.default);

    // 获取模块工厂
    // @ts-ignore
    const factory = await container.get(`./${subBundleName}`);
    // 执行模块工厂并返回模块
    return factory();
  } catch (e) {
    console.error('Failed to load remote module:', e);
    owlAddAjaxInfo('subPackage load failed', { subBundleName, error: e.message });
    throw e;
  }
}
